import React, { Component, Fragment } from 'react';
import {
  Container,
  NLink,
  MainNav,
  Box,
  Social,
  TextLinks,
  ALink,
  GLink,
} from './nav.css';
import LauvLogo from '../../../static/Logo.png';
import Instagram from '../../../static/instagramBlack.svg';
import Facebook from '../../../static/facebookBlack.svg';
import Twitter from '../../../static/twitterBlack.svg';
import Messenger from '../../../static/messengerBlack.svg';

class Nav extends Component {
  state = {
    isOpen: false,
    deep: false,
  };

  componentDidMount() {
    if (typeof window !== 'undefined') {
      if (document.location.pathname !== '/') {
        this.setState({ deep: true });
      }
    }
  }

  menuChange = e => {
    if (!e.isOpen) {
      this.setState({ isOpen: false });
    }
  };

  toggleMenu = () => {
    this.setState(state => {
      return {
        isOpen: !state.isOpen,
      };
    });
  };

  render() {
    return (
      <Container isOpen={this.state.isOpen}>
        <Box>
          <MainNav>
            <GLink to="/">
              <h1>
                <img src={LauvLogo} width="200px" alt="Lauv" />
              </h1>
            </GLink>

            <div className="navWrapper">
              <TextLinks desktop>
                <Fragment>
                  <GLink to="/preorder">Preorder</GLink>
                  <NLink
                    to="music"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                    isDynamic={true}
                    href="#"
                  >
                    Listen
                  </NLink>
                  <NLink
                    to="videos"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                    isDynamic={true}
                    href="#"
                  >
                    Watch
                  </NLink>
                  <NLink
                    to="tour"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                    isDynamic={true}
                    href="#"
                  >
                    Tour
                  </NLink>
                </Fragment>
                <GLink to="/help">Help</GLink>
                <ALink
                  href="https://shop.lauvsongs.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Store
                </ALink>
              </TextLinks>
              <Social>
                <a
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/lauvsongs/"
                  target="_blank"
                >
                  <img src={Instagram} alt="Lauv on Instagram" />
                </a>
                <a
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/lauvsongs/"
                  target="_blank"
                >
                  <img src={Facebook} alt="Lauv on Facebook" />
                </a>
                <a
                  rel="noopener noreferrer"
                  href="https://twitter.com/lauvsongs"
                  target="_blank"
                  style={{ position: 'relative', top: '1px' }}
                >
                  <img src={Twitter} alt="Lauv on Twitter" />
                </a>
                <a
                  rel="noopener noreferrer"
                  href="https://m.me/lauvsongs"
                  target="_blank"
                  style={{ position: 'relative', top: '1px' }}
                >
                  <img src={Messenger} alt="Lauv on Facebook Messenger" />
                </a>
              </Social>
            </div>
          </MainNav>
        </Box>
      </Container>
    );
  }
}

export default Nav;
